import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';

import { AppState, IPageState } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const outerTheme = createTheme({

  palette: {
    secondary: {
      main: "#3a87ad", dark: "#005a7e"
    },
  },
});

type DialogErrorProps = {
  classes?: any,
  page: IPageState,
  close: () => void,
  open: boolean,
  openOrder: () => void,
  //message? : string,
  //message1? : string,
  errorType: number,
  errorColor: number
}

class DialogError extends React.Component<DialogErrorProps, any> {
  constructor(props: any) {
    super(props, {});
  }
  state = {
  };


  // componentDidUpdate(prevProps: DialogErrorProps) {
  //     if(this.props.page.dialogError !== prevProps.page.dialogError)
  //       this.setState({
  //         open: true
  //       });
  //   };



  // openDialogInfo = () => {
  //     this.props.openOrder()
  // };

  //PM 2021-09-01
  //usuniecie disableBackdropClick
  render() {
    const classes = this.props.classes;

    let sum: number = 0;

    for (const itm of this.props.page.basket) {
      sum = sum + parseFloat(itm.cena.replace(',', '.'));
    }


    let ilosc = this.props.page.basket.length
    let iloscMin = this.props.page.minItems
    let iloscMax = this.props.page.info.www_sprzedaz_ilosc_limit
    
    let sumMin = this.props.page.info.www_sprzedaz_kwota_limit_min
    let sumMax = this.props.page.info.www_sprzedaz_kwota_limit_max


    let iloscError = ilosc < iloscMin || ilosc > iloscMax
    let sumError = sum < sumMin || sum > sumMax

    return (

      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        open={this.props.open}
      //fullWidth               
      >
        <DialogTitle disableTypography>
          <Typography gutterBottom variant="h5" component="h2" color="error" style={{ fontSize: "1.25rem" }}>
            <b>uwaga</b>
          </Typography>
          <hr className={classes.hr} />
        </DialogTitle>
        <DialogContent >
          <DialogContentText className={classes.dialogContentText} >
            <Typography gutterBottom variant="h5" component="h2" >
              Zamówienie:
            </Typography>
            {this.props.errorType == 0  ?
              <>
                {sumError ?
                <Typography gutterBottom variant="h5" component="h2" className={classes.padding}>
                  {'  * ' + 'minimalna kwota:'} <b className={classes.secondary}>{sumMin + ".00 zł"}</b>
                </Typography> : null }
                {iloscError ? 
                  <Typography gutterBottom variant="h5" component="h2" className={classes.padding} >
                  {'  * ' + 'minimalna ilość:'} <b className={classes.secondary}>{iloscMin}</b>
                </Typography> : null}   
              </>
              : 
              <>
               {sumError ?
                <Typography gutterBottom variant="h5" component="h2" className={classes.padding}>
                  {'  * ' + 'maksymalna kwota:'} <b className={classes.secondary}>{sumMax + ".00 zł"}</b>
                </Typography> : null}
                {iloscError ?
                <Typography gutterBottom variant="h5" component="h2" className={classes.padding} >
                  {'  * ' + 'maksymalna ilość :'} <b className={classes.secondary}>{iloscMax}</b>
                </Typography> : null}
              </>
            }
            {/* <Typography gutterBottom variant="h5" component="h2" className={classes.padding}>
              {'  * '}
            </Typography> */}
            {}
            {sumError ? 
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} >
              {'  * ' + 'twoja kwota:'} <b className={this.props.errorColor == 2 ? classes.error : this.props.errorColor == 0 ? classes.error : classes.secondary}>{sum.toFixed(2) + ' zł'}</b>
            </Typography> : null}

              {iloscError ? 
            <Typography gutterBottom variant="h5" component="h2" className={classes.padding} >
              {'  * ' + 'twoja ilość:'} <b className={this.props.errorColor == 2 ? classes.error : this.props.errorColor == 1 ? classes.error : classes.secondary}>{ilosc}</b>
            </Typography> : null}

            {/* <Typography gutterBottom variant="h5" component="h2" >
                    {this.props.message}
                  </Typography>
                  {this.props.message1 != "" ? <Typography gutterBottom variant="h5" component="h2" >
                    {this.props.message1} <b className={classes.secondary}>{this.props.val}</b>.
                  </Typography> : null}
                  <Typography gutterBottom variant="h5" component="h2" >
                    {"Czy na pewno wykonać zamówienie?"}
                  </Typography> */}
          </DialogContentText>
        </DialogContent >
        <DialogActions >
          <ThemeProvider theme={outerTheme}>
            <Button onClick={() => this.props.close()} variant="outlined" size="small" color="secondary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b><Trans>OK</Trans></b>
            </Button>
            {/* <Button onClick={() => this.openDialogInfo()}  variant="contained" size="small" color="secondary"
                        style={{ textTransform: "none", fontSize: "0.8rem" }}
                >
                  <b><Trans>Next</Trans></b>
                </Button> */}
          </ThemeProvider>
        </DialogActions>
      </Dialog>

    );
  }
}

const styles = (theme: Theme) => ({
  primary: {
    color: theme.palette.primary.main
  },
  secondary: {
    //color: theme.palette.secondary.main
    color: "#3a87ad"
  },
  error: {
    //color: theme.palette.secondary.main
    color: "#c00"
  },
  padding: {
    whiteSpace: "pre" as "pre"
  },
  hr: {
    marginTop: "10px",
    minWidth: "320px"

  }

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogError));